import { fromJS } from "immutable";
import * as constants from "./constants";

const defaultState = fromJS({
  tab1Arr: [
    { name: "一级建造师", id: 1011 },
    { name: "二级建造师", id: 1012 },
    { name: "消防工程师", id: 1060 },
    { name: "安全工程师", id: 1033 },
    { name: "监理工程师", id: 1013 },
    { name: "一级造价师", id: 1015 },
    { name: "二级造价师", id: 1093 },
    { name: "造价实操课", id: 1110 },
    { name: "土建中级职称", id: 1061 },
    { name: "咨询工程师", id: 1087 },
    { name: "公路水运检测", id: 1081 },
    { name: "BIM工程师", id: 1069 },
    { name: "口碑", id: 1 },
  ],
  tab2Arr: [
    { name: "备考技巧", id: 1 },
    { name: "热门知识", id: 2 },
    { name: "习题讲解", id: 3 },
  ], //[{"name": "名师说", "id": 1}, {"name": "学霸说", "id": 2}]
  tab3Arr: [], //[{"name": "全部课程", "id": 1}, {"name": "考试介绍", "id": 2}, {"name": "学习方法", "id": 2}]
  tab4Arr: [

    {
      name: "最热",
      id: 1,
    },
    {
      name: "最新",
      id: 0,
    }
  ],
  curTab1Id: null,
  curTab2Id: null,
  curTab3Id: null,
  curTab4Id: 1,
  isLoader: true,
  bottomList: [],
  page: 1,
  total: 0,
});

export default (state = defaultState, action) => {
  switch (action.type) {
    case constants.CHANGE_TAB_1:
      return state.set("curTab1Id", action.id);
    case constants.CHANGE_TAB_2:
      return state.set("curTab2Id", action.id);
    case constants.CHANGE_TAB_3:
      return state.set("curTab3Id", action.id);
    case constants.CHANGE_TAB_4:
      return state.set("curTab4Id", action.id);
    case constants.CHANGE_TAB_2_ARR:
      return state.set(
        "tab2Arr",
        fromJS([
          { name: "备考技巧", id: 1 },
          { name: "热门知识", id: 2 },
          { name: "习题讲解", id: 3 }
        ])
      );
    case constants.CHANGE_TAB_2_ARR_TELL:
      return state.set(
        "tab2Arr",
        fromJS([
          { name: "名师说", id: 1 },
          { name: "学霸说", id: 2 },
          { name: "品牌故事", id: 3 },
        ])
      );
    case constants.CHANGE_TAB_3_ARR:
      return state.set("tab3Arr", fromJS(action.arr));
    case constants.SET_LOADER:
      return state.set("isLoader", action.value);
    case constants.CHANGE_LIST:
      return state.set("bottomList", fromJS(action.list));
    case constants.SET_PAGE:
      return state.set("page", action.page);
    case constants.SET_TOTAL:
      return state.set("total", action.total);
    default:
      return state;
  }
};
